import { Box, IconWithVariant } from '@auviknetworks/iceberg-ui';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    FormLabel,
    Typography
} from '@mui/material';
import { TenantPicker } from 'application/Shared/Components/Pickers/Tenant';
import { FontSizes } from 'application/Shared/Constants/SizeArrays';
import { FormFactoryContextType } from 'application/Shared/Contexts/FormFactoryContext';
import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { ApplicationSelect } from './ApplicationSelect';

export const FormContextManager = ({
    clientId,
    applicationId,
    setSaasOpsContext
}: {
    clientId: string;
    applicationId: string;
    setSaasOpsContext: Dispatch<SetStateAction<FormFactoryContextType>>;
}) => {
    const { t } = useTranslation();
    return (
        <Box sx={{ marginBottom: '16px' }}>
            <Accordion>
                <AccordionSummary
                    expandIcon={
                        <IconWithVariant
                            data-testid="expandAccordionIconAdminUser"
                            variant="primary"
                            src="ChevronDown"
                            size={FontSizes[2]}
                        />
                    }
                >
                    <Typography variant="h6">
                        {t('Admin.FormBuilder.ContextManager.title')}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box marginBottom="16px">
                        {t('Admin.FormBuilder.ContextManager.description')}
                    </Box>
                    <FormLabel>{t('Common.tenant')}</FormLabel>
                    <TenantPicker
                        sx={{ marginBottom: '16px' }}
                        size="sm"
                        variant="outlined"
                        color="secondary"
                        onChange={(value: string) => {
                            setSaasOpsContext(
                                (prev: FormFactoryContextType) => ({
                                    ...prev,
                                    clientId: value
                                })
                            );
                        }}
                    />
                    {clientId && (
                        <ApplicationSelect
                            clientId={clientId}
                            onChange={(value) =>
                                setSaasOpsContext((prev) => ({
                                    ...prev,
                                    applicationId: value
                                }))
                            }
                            value={applicationId}
                        />
                    )}
                </AccordionDetails>
            </Accordion>
        </Box>
    );
};
